export default "__VITE_ASSET__CBbev3rb__"